import React from "react";
import { useFormContext } from "react-hook-form";

interface Props {
    name: any;
    children: (value: any | any[]) => React.ReactElement<any> | undefined;
}

const FormWatcher = ({ name, children }: Props) => {
    const { watch } = useFormContext();
    const value = watch(name);
    return children(value);
};

export default FormWatcher;
